import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

interface LockedDownloadButtonProps {
  className?: string;
}

// Shown in place of a Download button for free users, who can preview but not download images.
export const LockedDownloadButton: React.FC<LockedDownloadButtonProps> = ({
  className = 'px-4 py-2 rounded-lg text-sm',
}) => (
  <Link
    to="/pricing"
    className={`inline-flex items-center justify-center gap-2 font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors ${className}`}
  >
    <Lock className="w-4 h-4" />
    Buy credits to download
  </Link>
);
